import React from 'react';
import PropTypes from 'prop-types';
import { dt } from '../../helpers/Utils/GetTailwindToken';

const Chevron = ({ direction, containerStylesOverride }) => {
    const chevronBeforeStyles = [
        'before:absolute',
        'before:top-1/2',
        direction === 'reverseArrow' ? 'before:left-1/2' : 'before:left-1/3',
        'before:w-3/5',
        'before:h-3/5',
        'before:border-t',
        'before:border-r',
        'before:border-solid',
        'before:-translate-x-1/2',
        'before:-translate-y-1/2',
        'before:rotate-45',
    ];
    const chevronStyles = [
        'w-3',
        'h-3',
        'relative',
        '-translate-y-1/2',
        'top-2/4',
        'mt-0.5',
        ...containerStylesOverride,
    ];
    const arrowStyles = ['before:-translate-x-1/2', 'before:-translate-y-1/2', 'before:rotate-45'];
    const reverseArrowStyles = [
        'before:-translate-x-1/2',
        'before:-translate-y-1/2',
        'before:rotate-[-135deg]',
    ];
    const arrowToRender = direction === 'reverseArrow' ? reverseArrowStyles : arrowStyles;
    return <div className={dt([...chevronBeforeStyles, ...chevronStyles, ...arrowToRender])} />;
};

Chevron.propTypes = {
    direction: PropTypes.oneOf(['arrow', 'reverseArrow']).isRequired,
    containerStylesOverride: PropTypes.array,
};

Chevron.defaultProps = {
    containerStylesOverride: [],
};

export default Chevron;
